import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Sidebar from "./Siderbar";
import Topbar from "./Topbar";
import Footer from "./Footer";

const DataDisplay = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL; // Use environment variable for API base URL
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${baseURL}/fetch-demo-product`);
        setData(response.data.products); // Assuming the API returns { products: [...] }
      } catch (err) {
        setError(err.message || 'Error fetching data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [baseURL]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;

  return (
    <>
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: "100vh" }}>
          <Topbar />
          <div className="flex-grow-1 p-4"></div>
          <div className="container">
            <h1 className="text-center">Product</h1>
            <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th>ID</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Edit</th>
                  {/* Add more columns here if needed */}
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.pid} style={{ textAlign: 'center' }}>
                    <td style={{ padding: 10 }}>{item.pid}</td>
                    <td style={{ padding: 10 }}>
                      <img src={`${baseURL}/images/${item.image}`} style={{ width: 100 }} />
                    </td>
                    <td style={{ padding: 10 }}>{item.pname}</td>
                    <td style={{ padding: 10 }}>
                      <Link to={`/admin_inndus_product_edit/${item.pid}`} replace>
                        Edit
                      </Link>
                    </td>
                    {/* Render more fields dynamically if needed */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default DataDisplay;
